export const MeetingProvider = Object.freeze({
    'None': 0,
    'Google Meet': 1,
    'Microsoft Teams': 2,
    Zoom: 3
})

export const JoinType = Object.freeze({
    Host: 0,
    Guest: 1
})

export const Channel = Object.freeze({
    SMS: 0,
    Chat: 1,
    Email: 2
})